var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlayCircle48Line = function SvgIconPlayCircle48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40.7c-9.21 0-16.7-7.49-16.7-16.7 0-9.21 7.49-16.7 16.7-16.7 9.21 0 16.7 7.49 16.7 16.7 0 9.21-7.49 16.7-16.7 16.7Zm0-30c-7.33 0-13.3 5.97-13.3 13.3 0 7.33 5.97 13.3 13.3 13.3 7.33 0 13.3-5.97 13.3-13.3 0-7.33-5.97-13.3-13.3-13.3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.42 22.97-9.6-5.8A1.2 1.2 0 0 0 19 18.2v11.6c0 .93 1.02 1.51 1.82 1.03l9.6-5.8c.77-.47.77-1.59 0-2.05v-.01Z",
    fill: "current"
  })));
};
export default SvgIconPlayCircle48Line;